import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  undo: {
    id: 'pd.common.undo',
    defaultMessage: 'Vratit zpět',
  },
});
